/**
 * Korean language translations.
 * Format: {'property': 'translation value';}
 */
export const LANG_KO_TRANS = {
    // menu
    'lvt.menu.twroute': 'Routes',
    'lvt.menu.twcalloff': 'twCalloff',
    'lvt.menu.twslot': 'twSlot',
    'lvt.menu.slot_booking': 'Smart Booking',
    'lvt.menu.twdoc': 'twDoc',
    'lvt.menu.twcost': 'twCost',
    'lvt.menu.lvt': 'Live Tracking',
    'lvt.menu.app_name': 'Transwide',
    'lvt.menu.my_profile': '나의 프로필',
    'lvt.menu.tw_profile': 'TW 프로필',
    'lvt.menu.company_profile': '회사 프로필',
    'lvt.menu.my_notifications': '나의 통지',
    'lvt.menu.sign_out': '로그아웃',

    // footer
    'lvt.footer.back_to_top': '맨 위로 돌아가기',
    'lvt.footer.terms_of_use': '이용 조건',
    'lvt.footer.privacy_policy': '개인정보 보호정책',
    'lvt.footer.support_information': '지원정보',
    'lvt.footer.transwide_home': '트랜스와이드 홈',
    'lvt.footer.license_nr': '라이스선스 번호:',
    'lvt.footer.build_version': '빌드 버전:',

    // order list columns
    'lvt.order_list.header': '주문 목록',
    'lvt.order_list.column.shipperCompany': '화주 회사',
    'lvt.order_list.column.reference': '참고',
    'lvt.order_list.column.status': '상태',
    'lvt.order_list.column.statusReason': '상태 이유',
    'lvt.order_list.column.senderCompany': '발송인 회사',
    'lvt.order_list.column.senderZipcode': '발송인 우편번호',
    'lvt.order_list.column.senderCity': '발송인 도시',
    'lvt.order_list.column.receiverCompany': '수취인 회사',
    'lvt.order_list.column.receiverZipcode': '수취인 우편번호',
    'lvt.order_list.column.receiverCity': '수취인 도시',
    'lvt.order_list.column.carrierName': '운송회사명',
    'lvt.order_list.column.plannedPickupEndDate': '계획된 픽업',
    'lvt.order_list.column.etaPickup': 'ETA 픽업',
    'lvt.order_list.column.delayAtPickup': '픽업 지연',
    'lvt.order_list.column.plannedDeliveryEndDate': '계획된 인도',
    'lvt.order_list.column.etaDelivery': 'ETA 인도',
    'lvt.order_list.column.delayAtDelivery': '인도 지연',
    'lvt.order_list.column.timestamps': '타임 스탬프',
    'lvt.order_list.column.bookingPickupTime': 'Booking pickup',
    'lvt.order_list.column.bookingDeliveryTime': 'Booking delivery',

    // status order list
    'lvt.order_list.status.requested': '요청',
    'lvt.order_list.status.failed': '오류',
    'lvt.order_list.status.waiting': '대기',
    'lvt.order_list.status.active': '활동적',
    'lvt.order_list.status.stopped': '오류',
    'lvt.order_list.status.completed': '완료',
    'lvt.order_list.status.cancelled': '취소',
    'lvt.order_list.status.timeout': '멈춤',

    // status reason order list
    'lvt.order_list.status_reason.carrier_not_assigned': '운송회사 미지정',
    'lvt.order_list.status_reason.plate_number_not_present': '현존하지 않은 등록번호',
    'lvt.order_list.status_reason.plate_number_not_recognized': '인정되지 않는 등록번호',
    'lvt.order_list.status_reason.plate_number_not_operational': '작동되지 않는 등록번호',
    'lvt.order_list.status_reason.technical_error_not_posted': 'GH에서 투어를 생성할 때의 기술적 오류',

    // pagination
    'lvt.order_list.pagination.rows_per_page': '페이지당 줄',
    'lvt.order_list.pagination.first': '첫 번째',
    'lvt.order_list.pagination.previous': '이전',
    'lvt.order_list.pagination.next': '다음',
    'lvt.order_list.pagination.last': '마지막',
    'lvt.order_list.pagination.no_orders_found': '주문 없음',

    // tracked device
    'lvt.map.tracked_device.trailer': '트레일러',
    'lvt.map.tracked_device.tractor': '트랙터',
    'lvt.map.tracked_device.mobile': '모바일',

    // map
    'lvt.map.button.open_settings': 'Open settings',
    'lvt.map.button.open_order_list': '공개된 주문 목록',
    'lvt.map.traffic_information.traffic': '트래픽',
    'lvt.map.traffic_information.fast': '빠름',
    'lvt.map.traffic_information.slow': '느림',
    'lvt.map.pickup_popup.pickup': '픽업',
    'lvt.map.pickup_popup.date': '날짜',
    'lvt.map.pickup_popup.address': '주소',
    'lvt.map.delivery_popup.delivery': '인도',
    'lvt.map.delivery_popup.date': '날짜',
    'lvt.map.delivery_popup.address': '주소',
    'lvt.map.current_gps_popup.in_transit_to_at_delivery': '인도 시 이동 중',
    'lvt.map.current_gps_popup.in_transit_to_at_pickup': '픽업 시 이동 중',
    'lvt.map.current_gps_popup.current_speed': '현재 속도',
    'lvt.map.current_gps_popup.average_speed': '평균 속도',
    'lvt.map.current_gps_popup.last_location_update': '마지막 위치 업데이트',
    'lvt.map.current_gps_popup.eta': 'ETA',
    'lvt.map.current_gps_popup.planned_time': '계획된 시간',
    'lvt.map.current_gps_popup.arrival_delay': '도착 지연',
    'lvt.map.current_gps_popup.speed_unit': 'km/h',

    // timestamps
    'lvt.order_list.timestamp.arrived_at_origin': '기점 도착',
    'lvt.order_list.timestamp.not_arrived_at_origin': '기점 미도착',
    'lvt.order_list.timestamp.left_origin': '왼쪽 기점',
    'lvt.order_list.timestamp.not_left_origin': '왼쪽 기점 아님',
    'lvt.order_list.timestamp.arrived_at_destination': '목적지에 도착',
    'lvt.order_list.timestamp.not_arrived_at_destination': '목적지에 도착하지 않음',
    'lvt.order_list.timestamp.left_destination': '왼쪽 목적지',
    'lvt.order_list.timestamp.not_left_destination': '왼쪽 목적지 아님',

    // settings
    'lvt.settings.header': 'Settings',
    'lvt.settings.delay_management': 'Delay management',
    'lvt.settings.add_new': 'Add new +',
    'lvt.settings.column.ruleTitle': 'Rule title',
    'lvt.settings.column.type': 'Type',
    'lvt.settings.column.offset': 'Offset',
    'lvt.settings.column.actions': 'Actions',
    'lvt.settings.create_rule': 'Create rule',
    'lvt.settings.view_rule': 'View rule',
    'lvt.settings.go_back_to_list': 'Go back to list',
    'lvt.settings.edit_rule': 'Modify rule',
    'lvt.settings.delete_rule': 'Delete rule',
    'lvt.settings.delete_this_rule': 'Delete this rule',
    'lvt.settings.rule_type.delay': 'Delay',
    'lvt.settings.rule_type.at_risk': 'At risk',
    'lvt.settings.no_rules_found': 'No rules found',
    'lvt.settings.delete_popup.message': 'Are you sure you want to delete this rule?',
    'lvt.settings.field.rule_title': 'Rule title',
    'lvt.settings.field.location_type': 'Location type',
    'lvt.settings.field.location_type_pickup': 'Pickup',
    'lvt.settings.field.location_type_delivery': 'Delivery',
    'lvt.settings.field.rule_type': 'Rule type',
    'lvt.settings.field.rule_type_delay.time_offset': 'Time offset threshold',
    'lvt.settings.field.rule_type_delay.unit_minutes': 'Minutes',
    'lvt.settings.field.rule_type_delay.unit_hours': 'Hours',
    'lvt.settings.field.rule_type_delay.before': 'Before',
    'lvt.settings.field.rule_type_delay.after': 'After',
    'lvt.settings.field.rule_type_atrisk.percentage': 'Percentage threshold',
    'lvt.settings.field.schedule_date_priority': 'Schedule date priority',
    'lvt.settings.field.schedule_date_priority.booking_time': 'Booked timeslot',
    'lvt.settings.field.schedule_date_priority.planned_earliest_arrival': 'Earliest planned arrival',
    'lvt.settings.field.schedule_date_priority.planned_latest_arrival': 'Latest planned arrival',
    'lvt.settings.field.error.required': 'is required',

    // popup
    'lvt.popup.yes': 'Yes',
    'lvt.popup.cancel': 'Cancel',

    // messages from backend
    'lvt.message.info_saved_successfully': 'Info saved successfully.',
    'lvt.message.info_updated_successfully': 'Info updated successfully.',
    'lvt.message.info_deleted_successfully': 'Info deleted successfully.',
    'lvt.message.warn': 'Warning: ',
    'lvt.message.error': 'Error: ',
    'lvt.message.error_no_name_specified': 'No name specified.',
    'lvt.message.error_no_company_id_specified': 'No company Id specified.',
    'lvt.message.error_no_location_type_specified': 'No location type specified.',
    'lvt.message.error_no_rule_type_specified': 'No rule type specified.',
    'lvt.message.error_date_priorities_not_specified': 'Date priorities not specified.',
    'lvt.message.error_delay_offset_not_specified': 'Delay offset not specified.',
    'lvt.message.error_at_risk_offset_not_specified': 'At risk offset not specified.',
    'lvt.message.error_no_entity_found': 'No entity found.',
    'lvt.message.error_could_not_convert_delay_rule': 'Could not convert delay rule.',

    // search
    'lvt.order_list.search': 'Search'
};



// WEBPACK FOOTER //
// ./src/app/services/translation/lang/lang-ko.ts